import { render } from "./ProjectsSiGePlan.vue?vue&type=template&id=645cac9c"
import script from "./ProjectsSiGePlan.vue?vue&type=script&lang=js"
export * from "./ProjectsSiGePlan.vue?vue&type=script&lang=js"

import "./ProjectsSiGePlan.vue?vue&type=style&index=0&id=645cac9c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__